interface OriginRelaySymbolProps {
  className?: string
}

/**
 * Origin Relay symbol - the app icon for header and branding
 * Uses white fill to match the brand identity
 */
export function OriginRelaySymbol({ className }: OriginRelaySymbolProps) {
  return (
    <svg
      viewBox="10 10 120 120"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M121.827 93.5985C120.408 88.1233 118.682 82.4829 116.734 76.7005C115.366 72.6376 115.366 68.1437 116.734 64.0808C118.682 58.2983 120.404 52.658 121.827 47.1828C125.208 33.1874 106.865 14.799 92.8255 18.1649C87.4706 19.5452 81.9549 21.2189 76.3107 23.1128C72.2417 24.4747 67.7456 24.4747 63.6811 23.1128C58.0369 21.2189 52.5212 19.5452 47.1663 18.1649C33.1315 14.7945 14.7842 33.1828 18.1689 47.1782C19.588 52.6534 21.3148 58.2937 23.2621 64.0762C24.6307 68.1391 24.6307 72.633 23.2621 76.6959C21.3148 82.4783 19.5926 88.1187 18.1689 93.5939C14.7842 107.589 33.1315 125.978 47.1709 122.612C52.5258 121.231 58.0415 119.558 63.6857 117.664C67.7502 116.302 72.2509 116.302 76.3153 117.664C81.9595 119.558 87.4752 121.231 92.8301 122.612C106.87 125.978 125.212 107.589 121.832 93.5939L121.827 93.5985ZM69.9959 107.057C49.7152 107.057 33.2738 90.6408 33.2738 70.3906C33.2738 50.1405 49.7152 33.7194 70.0005 33.7194C90.2858 33.7194 106.723 50.1359 106.723 70.386C106.723 90.6362 90.2812 107.053 70.0005 107.053L69.9959 107.057Z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  )
}
